import { render } from "./IconWallet.vue?vue&type=template&id=185f3c97"
import script from "./IconWallet.vue?vue&type=script&lang=js"
export * from "./IconWallet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconWallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "185f3c97"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('185f3c97', __exports__)) {
    api.reload('185f3c97', __exports__)
  }
  
  module.hot.accept("./IconWallet.vue?vue&type=template&id=185f3c97", () => {
    api.rerender('185f3c97', render)
  })

}


export default __exports__